'use strict';

module.exports = {
  Promish: null
};
//# sourceMappingURL=promish.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/exceljs/dist/es5/utils/promish.js
// module id = 95
// module chunks = 0